export default "__VITE_ASSET__CgmQ9Agh__"